export default "__VITE_ASSET__DzlGTW$I__"